import NearbyAirports from './NearbyAirports';

export default NearbyAirports;
